<template>
<div id="allmembers">
  <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{'general._wait_'|translate}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  <v-card>
    <v-toolbar card dense color="transparent">
      <v-toolbar-title><h4>{{$t('dashboard._Valid_members_')}}: {{this.members.length}}</h4></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        right
        append-icon="search"
        label="Recherche"
        single-line
        hide-details
      ></v-text-field>
      <v-btn icon>
        <v-icon>more_vert</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      
         <v-btn color="primary" @click="download_qrs" v-show="selected.length>0" >download Qrs</v-btn>
         <v-btn color="primary"  @click="download_images" v-show="selected.length>0" >download Photos</v-btn>
         <v-btn color="primary" @click="filtred_list" v-show="search != ''">Prepare the filtred list to exported</v-btn>
     <!-- <v-btn color="primary" @click="download_images" >download_images</v-btn> -->

<!-- <v-btn color="primary" @click="down2" >down2</v-btn> -->
     
      <img id="myImg" src="" /> 
      <template>

      <download-excel   
	class   = "btn btn-default"
	:data   = "selected_filter"
	:fields = "json_fields"
  type    = "csv"
	name    = "all_members_filtred.csv">
  <button type="button"  v-show = "search != ''"  class="mb-2 v-btn theme--dark primary">{{'general._ExporttoCSV_'|translate}} filtred_list
</button> 
</download-excel>
///////////////////////////

        <download-excel
	class   = "btn btn-default"
	:data   = "members"
	:fields = "json_fields"
  type    = "csv"
	name    = "all_members.csv">
  <button type="button" class="mb-2 v-btn theme--dark primary">{{'general._ExporttoCSV_'|translate}}
</button> 
</download-excel>


<input type="checkbox" class="form_checkbox" v-model="selectAll" @click="select">

        <v-data-table
           ref="members_data_table"
          :headers="headers"
          :items="members"
          class="elevation-0"
          :pagination.sync="pagination"
          :search="search"
          item-key="id"
        >
          <template slot="items" slot-scope="props">
            <tr class="text-xs-left"  style="cursor: pointer">
               <td class="text-xs-left"> <input  class="form_checkbox" type="checkbox" :value="{id:props.item.id,qr_url:props.item.qr_url,image_url:props.item.imageUrl}" v-model="selected"></td>
            <td class="text-xs-left">
              <v-avatar size="36px">
                <img :src="props.item.imageUrl" :alt="props.item.firstName" />
              </v-avatar>
            </td>
            <td class="text-xs-left">{{ props.item.firstName }} {{ props.item.lastName }}</td>
            <td class="text-xs-left">{{ props.item.phone }}</td>
            <td class="text-xs-left">{{ props.item.accessCode }}</td>
            <td class="text-xs-left">{{ props.item.role }}</td>
            <td class="text-xs-left">{{ props.item.churchName }}</td>
            <td class="text-xs-left">{{ props.item.createdBy }}</td>
            <td class="text-xs-left">{{ props.item.createdDate }}</td>
             <td class="text-xs-left">

                  <div v-viewer class="images clearfix">

              <template >
                <img :src="props.item.qr_url" class="image" >
                </template>
            </div>
             
                </td>
              <td class="text-xs-right">
               <v-btn @click.stop="deleteItem(props.item)" flat icon color="grey">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
                 <td class="text-xs-right">
               <v-btn @click.stop="editItem(props.item)" flat icon color="grey">
                 <v-icon>edit</v-icon>
              </v-btn>
            </td>
            </tr>
          </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</div>
</template>

<script>
/* eslint-disable */ 
import { db } from '@/api/firebaseInit';
import firebase from 'firebase';
import { storage } from '@/api/firebaseInit';
export default {
  data () {
    return {
      selected_filter:[],
        selected: [],
      selectAll: false,
      search: '',
      loading: true,


        headers: [
             { text:'', value: 'lastName' },
          {
            text:this.$t('members._photo_'),
            align: 'left',
            sortable: false,
            value: 'imageUrl'
          },
          { text:this.$t('members._fullname_'), value: 'lastName' },
          { text:this.$t('members._phone_'), value: 'phone' },
          { text:this.$t('members._access_code_') , value: 'accessCode' },
          { text:'Role' , value: 'role' },
          { text:this.$t('members._churchName_') , value: 'churchName' },
          { text:this.$t('members._createdBy_') , value: 'createdBy' },
          { text:this.$t('members._createdDate_') , value: 'createdDate' },
          { text:'registration_date' , value: 'createdDate' },
          { text:this.$t('members._qrcode_'), value: 'qr_link' },
                   {
            text: this.$t('members._delete_'),
            align: 'left',
            sortable: false,
            value: ''
          },
           {
            text: this.$t('members._edit_'),
            align: 'left',
            sortable: false,
            value: ''
          }
        
        ],

        json_fields: {
          "ID":'id',
        'Prenom': 'firstName',
         'Nom': 'lastName',
        'Sex': 'gender',
        'Date of birth':'dateOfBirth',
         'Role': 'role',  
            'Date cree': 'createdDate',
            'Qr Code': 'qr_url',
              'Image': 'imageUrl',
              "qr_name":"qr_name",
              "image_name":"image_name",
              "card_id":"card_id",
              "phone":"phone",
              "churchName":"churchName",
              "city":"city",
              "address":"address",
              "postalCode":"postalCode"
      },
        pagination: {
          sortBy: 'lastName',
          rowsPerPage: '100'
        },
    };
  },
   computed: {
    members () {
      let members = this.$store.getters.valideUsers;
      this.loading = false;
      return members;
    },

      
  },
  watch: {
    
    members(val) {
     let members = this.$store.getters.valideUsers;
      return members
    }

  },

  methods: {   
    
     ischurchName(member) { 
    return member.churchName === this.search;
},
filtred_list () {
  this.selected_filter=[];
console.log(this.$refs.members_data_table.filteredItems.length)
this.selected_filter =this.$refs.members_data_table.filteredItems;
},

      select() {
      this.selected = [];
      if (!this.selectAll) {
        for (let i in this.members) {
          this.selected.push(this.members[i].id);
        }

        

      }
    },
    
   download_qrs : async function(){
      
  
        for(var i=0;i<this.selected.length;i++){
           
             
                    var storageRef = storage.ref();
                   
                    var url2 = this.selected[i].qr_url
                    var file_name= url2.substring(
                                   url2.lastIndexOf("%2F") + 3, 
                                   url2.lastIndexOf("?")
                                            )
                                            var id = this.selected[i].id
                                  await this.sleep(500);            
             storageRef.child('census/'+id+'/qr_code/'+file_name).getDownloadURL().then(function(url) {
                console.log(url)
                     // This can be downloaded directly:
                    
                      var xhr = new XMLHttpRequest();
                      xhr.responseType = 'blob';
                      
                      xhr.onload = function(event) {
                         
                        var blob = xhr.response;
                         
                          var a = document.createElement('a');

                        a.href = window.URL.createObjectURL(blob);

                        a.download = file_name+".png"; // Name the file anything you'd like.

                        a.style.display = 'none';

                        document.body.appendChild(a);

                        a.click();
                      };
                       //await this.sleep(1000);
                      xhr.open('GET', url);
                      xhr.send();
              // Or inserted into an <img> element:
               /*  var img = document.getElementById('myImg');
                img.src = url; */

                        }).catch(function(error) {
                              console.log('eeeeee'+JSON.stringify(error))
                        // Handle any errors

                        });
                
                    console.log(i)
               
    
        }
       
    },

    download_images : async function(){
      
  
        for(var i=0;i<this.selected.length;i++){
           
             
                    var storageRef = storage.ref();
                   
                    var url2 = this.selected[i].imageUrl
                    var file_name= url2.substring(
                                   url2.lastIndexOf("%2F") + 3, 
                                   url2.lastIndexOf("?")
                                            )
                                            var id = this.selected[i].id
                                  await this.sleep(500);            
             storageRef.child('census/'+id+'/qr_code/'+file_name).getDownloadURL().then(function(url) {
                console.log(url)
                     // This can be downloaded directly:
                    
                      var xhr = new XMLHttpRequest();
                      xhr.responseType = 'blob';
                      
                      xhr.onload = function(event) {
                         
                        var blob = xhr.response;
                         
                          var a = document.createElement('a');

                        a.href = window.URL.createObjectURL(blob);

                        a.download = file_name+".png"; // Name the file anything you'd like.

                        a.style.display = 'none';

                        document.body.appendChild(a);

                        a.click();
                      };
                       //await this.sleep(1000);
                      xhr.open('GET', url);
                      xhr.send();
              // Or inserted into an <img> element:
               /*  var img = document.getElementById('myImg');
                img.src = url; */

                        }).catch(function(error) {
                              console.log('eeeeee'+JSON.stringify(error))
                        // Handle any errors

                        });
                
                    console.log(i)
               
    
        }
       
    },

    down2 : async function(){
       for(var i=0;i<3;i++){
            await this.sleep(10);
               if(this.members[i].qr_url != undefined)  {
                    var storageRef = storage.ref();
                    var url = this.members[i].qr_url
                    var file_name= url.substring(
                                   url.lastIndexOf("%2F") + 3, 
                                   url.lastIndexOf("?"));

                  fetch(url,{
                  headers:{
    'Access-Control-Allow-Headers': '*'
  }}
                  )
  .then(res => res.blob()) // Gets the response and returns it as a blob
  .then(blob => {
    // Here's where you get access to the blob
    // And you can use it for whatever you want
    // Like calling ref().put(blob)

    // Here, I use it to make an image appear on the page
    let objectURL = URL.createObjectURL(blob);
    let myImage = new Image();
    myImage.src = objectURL;
    document.getElementById('myImg').appendChild(myImage)
});
                   
               }
       }
    },
           sleep(ms) {

        return new Promise(resolve => setTimeout(resolve, ms));
      },


    // for future use;
    editItem(item) {
      this.$store.commit('currentMemberId', item.id);
       this.fetchCurrentMember(item.id)
      // this.$store.commit('currentMemberId', item.id)
      //   // this.$store.dispatch('fetchCurrentMember', item.id)
      //   this.$router.push('/form/newmember')
      },
    deleteItem(item) {
        const index = this.members.findIndex(x => x.id == item.id )
        if (confirm(this.$t('members._confirm_delete_'))) {
          this.members.splice(index, 1)
          this.$store.dispatch('deleteMember', item.id)
        }
        
      },
   fetchCurrentMember (payload) {
    db.collection('Census').doc(payload)
      .get()
      .then((doc) => {
        const form = {
             id: doc.id,
             imageUrl: doc.data().imageUrl,
             firstName: doc.data().firstName,
             lastName: doc.data().lastName,
             posteName: doc.data().posteName,
             accessCode: doc.data().accessCode,
             role: doc.data().role,
             phone: doc.data().phone,
             email: doc.data().email,
             dateOfBirth: doc.data().dateOfBirth,
             address: doc.data().address,
             gender: doc.data().gender,
             consent: doc.data().consent,
             city: doc.data().city,
             postalCode: doc.data().postalCode,
             isWithChildren: doc.data().isWithChildren,
             hasSmartPhone: doc.data().hasSmartPhone,
             noPhoneReason: doc.data().noPhoneReason,
             isBuyPhoneReady: doc.data().isBuyPhoneReady,
             maritalStatus: doc.data().maritalStatus,
             noVolunteerReason: doc.data().noVolunteerReason,
             isVolunteer: doc.data().isVolunteer,
             hasChildren: doc.data().hasChildren,
             volunteerFrequency: doc.data().volunteerFrequency,
             niveauScolaire: doc.data().niveauScolaire,
             churchName: doc.data().churchName,
             churchAttendance: doc.data().churchAttendance,
             memberSince: doc.data().memberSince,
             sermonTimeSpent: doc.data().sermonTimeSpent,
             isreferralReady: doc.data().isreferralReady,
             noReferralReason: doc.data().noReferralReason,
             isVolunteerReady: doc.data().isVolunteerReady,
             noVolunteerReason: doc.data().noVolunteerReason,
             volunteerTime: doc.data().volunteerTime,
             noDonationReason: doc.data().noDonationReason,
             donation: doc.data().donation,
             isDimeContribution: doc.data().isDimeContribution,
             isDonationReady: doc.data().isDonationReady,
             // dimeAmount: doc.data().dimeAmount,
             dime: doc.data().dime,
             dimeType: doc.data().dimeType,
             isOffrandeContribution: doc.data().isOffrandeContribution,
             // offrandeAmount: doc.data().offrandeAmount,
             offrandeType: doc.data().offrandeType,
             offrande: doc.data().offrande,
             isGraceContribution: doc.data().isGraceContribution,
             // graceDonationAmount: doc.data().graceDonationAmount,
             graceContributionType: doc.data().graceContributionType,
             isWorking: doc.data().isWorking,
             createdDate: doc.data().createdDate,
             isWorkReady: doc.data().isWorkReady,
             notAvailableReason: doc.data().notAvailableReason,
             isEducationReady: doc.data().isEducationReady,
             education: doc.data().education,
             isHouseOwner: doc.data().isHouseOwner,
             houseOwnerSince: doc.data().houseOwnerSince,
             isRenting: doc.data().isRenting,
             jobSkills: doc.data().jobSkills,
             jobSearch: doc.data().jobSearch,
             jobType: doc.data().jobType,
             availableTime: doc.data().availableTime,
             jobDisponibility: doc.data().jobDisponibility,
             timeOnCurrentJob: doc.data().timeOnCurrentJob,
             jobPosition: doc.data().jobPosition,
             numberOfJobs: doc.data().numberOfJobs,
             jobRepartition: doc.data().jobRepartition,
             jobWeeklyHours: doc.data().jobWeeklyHours,
             jobTravelDistance: doc.data().jobTravelDistance,
             homeTravelDistance: doc.data().homeTravelDistance,
             jobTravelMode: doc.data().jobTravelMode,            
             jobTravelCost: doc.data().jobTravelCost,
             jobTravelTime: doc.data().jobTravelTime,
             jobMonthlyPay: doc.data().jobMonthlyPay
        }  
         if (doc.data().imageUrl === "./src/assets/avatar.png" ) {
           form.imageUrl = memberPhoto;
         } else {
           this.$store.commit('memberPhoto', form.imageUrl)
         }
         if (
          doc.data().isBuyPhoneReady === null ||
          doc.data().isBuyPhoneReady === undefined
         ) {
           form.isBuyPhoneReady = "Non";
         }
         if (
          doc.data().isVolunteerReady === null ||
          doc.data().isVolunteerReady === undefined
         ) {
           form.isVolunteerReady = "Non";
         }
         if (
          doc.data().volunteerTime === null ||
          doc.data().volunteerTime === undefined
         ) {
           form.volunteerTime = {
            nombre: 0,
            frequency: 'Par jour'
           }
         }
          if (
          doc.data().houseOwnerSince === null ||
          doc.data().houseOwnerSince === undefined
         ) {
           form.houseOwnerSince = {
            nombre: 0,
            frequency: 'Par jour'
           }
          }
          if (
          doc.data().offrande === null ||
          doc.data().offrande === undefined
         ) {
           form.offrande = {
            nombre: 0,
            frequency: 'Par jour'
           }
          }
           if (
          doc.data().donation === null ||
          doc.data().donation === undefined
         ) {
           form.donation = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
           if (
          doc.data().dime === null ||
          doc.data().dime === undefined
         ) {
           form.dime = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
          if (
          doc.data().timeOnCurrentJob === null ||
          doc.data().timeOnCurrentJob === undefined
         ) {
           form.timeOnCurrentJob = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
           if (
          doc.data().jobDisponibility === null ||
          doc.data().jobDisponibility === undefined
         ) {
           form.jobDisponibility = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
          if (
          doc.data().jobSearch === null ||
          doc.data().jobSearch === undefined
         ) {
           form.jobSearch = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
           if (
          doc.data().graceDonation === null ||
          doc.data().graceDonation === undefined
         ) {
           form.graceDonation = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
         if (
          doc.data().education === null ||
          doc.data().education === undefined
         ) {
          form.education = {
            nombre: 0,
            frequency: 'Par jour'
           }
         }
         if (
          doc.data().numberOfKids === null ||
          doc.data().noPhoneReason === undefined
         ) {
           form.numberOfKids = 0;
         }
         if (
          doc.data().noReferralReason === null ||
          doc.data().noReferralReason === undefined
         ) {
           form.noReferralReason = 'Pas de raison';
         }
         if (
          doc.data().noDonationReason === null ||
          doc.data().noDonationReason === undefined
         ) {
           form.noDonationReason = 'Pas de raison';
         }
         if (
          doc.data().notAvailableReason === null ||
          doc.data().notAvailableReason === undefined
         ) {
           form.notAvailableReason = 'Pas de raison';
         }
         form.consent = true
          this.$store.commit('currentMember', form)
        })
      this.$router.push('/form/newmember')
    },
  },
}
</script>

<style>
.image {
  height: 20px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}
</style>




// WEBPACK FOOTER //
// src/pages/widgets/AllMembers.vue